import * as React from 'react';

const Completed = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
    <path
      d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
      fill="#1FC70A"
    />
    <path
      d="M23.511 9.55615C24.0413 9.93457 24.1585 10.6631 23.7728 11.1835L15.9138 22.1868C15.7213 22.4465 15.4281 22.6167 15.1035 22.6573C14.7788 22.6978 14.4516 22.605 14.1989 22.4009L8.43252 17.7411C7.92639 17.3321 7.85398 16.5979 8.2708 16.1013C8.68762 15.6046 9.43582 15.5336 9.94195 15.9426L14.7351 19.8159L21.8526 9.81309C22.2382 9.29277 22.9807 9.17773 23.511 9.55615Z"
      fill="white"
    />
  </svg>
);

export default Completed;
